import { render } from "./programmatic-animation-using-coroutines.vue?vue&type=template&id=6e173f8f"
import script from "./programmatic-animation-using-coroutines.vue?vue&type=script&lang=ts"
export * from "./programmatic-animation-using-coroutines.vue?vue&type=script&lang=ts"
script.render = render

export default script